import React from 'react';
import Modal from 'react-modal';

const Header = props => {
  const { title, onClose } = props;

  return (
    <div className="modal-header">
      <div className="modal-header__title">{title}</div>
      <button className="modal-header__close" onClick={onClose}>
        <svg className="svg-icon--close svg-icon" viewBox="0 0 19.41 19.41">
          <path strokeWidth="2px" d="M.71.71l18 18M18.71.71l-18 18" />
        </svg>
      </button>
    </div>
  );
};

const AdChoicesIFrame = ({ lang, country }) => {
  let adChoicesURL;

  if (country === 'US') {
    adChoicesURL = '//info.evidon.com/pub_info/45?v=1&iptvn=0';
  }

  if (country === 'CA') {
    adChoicesURL =
      lang === 'en'
        ? '//info.evidon.com/pub_info/1111?v=1&nt=0'
        : '//info.evidon.com/pub_info/1112?v=1&nt=0';
  }

  const iframe = {
    __html: `<iframe src="${adChoicesURL}" className="modal-body__content" style="width:100%; height:450px;"></iframe>`
  };

  return (
    <div className="modal-body__inner">
      <div dangerouslySetInnerHTML={iframe} />
    </div>
  );
};

const AdChoicesModal = props => {
  const { isOpen, onAdChoicesClose, lang, country } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onAdChoicesClose}
      className="modal"
      overlayClassName="overlay">
      <Header title="" onClose={onAdChoicesClose} />
      <AdChoicesIFrame lang={lang} country={country} />
    </Modal>
  );
};

export default AdChoicesModal;
